module.exports = __webpack_public_path__ + "static/media/appURI_1200x250.72baa393.png";